import { getSocialIconUrl } from './socialIcons';

const getPadding = (content) => {
  const pt = content.paddingTop ?? content.padding ?? '16px';
  const pr = content.paddingRight ?? content.padding ?? '16px';
  const pb = content.paddingBottom ?? content.padding ?? '16px';
  const pl = content.paddingLeft ?? content.padding ?? '16px';
  return `${pt} ${pr} ${pb} ${pl}`;
};

export function EmailBlockRenderer({ block }) {
  const { type, content } = block;
  const paddingStr = getPadding(content);

  switch (type) {
    case 'HEADING':
    case 'TEXT':
    case 'QUOTE':
    case 'FOOTER': {
      const style =
        type === 'QUOTE'
          ? {
              backgroundColor: content.backgroundColor,
              borderLeft: content.borderLeft,
              padding: paddingStr,
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
            }
          : {
              padding: paddingStr,
              textAlign: content.align || 'left',
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
            };
      return (
        <div style={style}>
          <div
            dangerouslySetInnerHTML={{
              __html: content.html || 'Empty Text Block',
            }}
            className="ql-editor"
            style={{ padding: 0 }}
          />
        </div>
      );
    }

    case 'LOGO':
    case 'IMAGE':
      return (
        <div
          style={{ padding: paddingStr, textAlign: content.align || 'center' }}
        >
          {content.url ? (
            <img
              src={content.url}
              alt={content.alt || ''}
              style={{
                maxWidth: '100%',
                height: 'auto',
                width: content.width || '100%',
                borderRadius: content.borderRadius || '0',
                display: 'inline-block',
              }}
            />
          ) : (
            <div className="w-full h-32 bg-gray-100 flex items-center justify-center border border-dashed border-gray-300">
              <span className="text-gray-400 text-sm">No image provided</span>
            </div>
          )}
        </div>
      );

    case 'BUTTON':
      return (
        <div
          style={{ padding: paddingStr, textAlign: content.align || 'center' }}
        >
          <span
            style={{
              display: 'inline-block',
              backgroundColor: content.backgroundColor || '#22c55e',
              color: content.textColor || '#ffffff',
              padding: '12px 24px',
              borderRadius: content.borderRadius || '8px',
              textDecoration: 'none',
              fontWeight: content.fontWeight || 'bold',
              fontFamily: 'sans-serif',
              fontSize: content.fontSize || '16px',
            }}
          >
            {content.text || 'Button'}
          </span>
        </div>
      );

    case 'SOCIAL':
      return (
        <div
          style={{ padding: paddingStr, textAlign: content.align || 'center' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent:
                content.align === 'center'
                  ? 'center'
                  : content.align === 'right'
                    ? 'flex-end'
                    : 'flex-start',
              gap: content.spacing || '16px',
            }}
          >
            {(content.networks || []).map((net, i) => {
              const iconUrl = getSocialIconUrl(net.platform, net.iconUrl);
              return (
                <img
                  key={i}
                  src={iconUrl}
                  alt={net.platform}
                  style={{
                    width: content.iconSize || '32px',
                    height: content.iconSize || '32px',
                    objectFit: 'contain',
                  }}
                />
              );
            })}
          </div>
        </div>
      );

    case 'DIVIDER':
      return (
        <div style={{ padding: paddingStr }}>
          <div
            style={{
              height: content.height || '1px',
              backgroundColor: content.color || '#e5e7eb',
              width: '100%',
            }}
          ></div>
        </div>
      );

    case 'SPACER':
      return (
        <div style={{ height: content.height || '24px', width: '100%' }}></div>
      );

    default:
      return <div className="p-4 text-red-500">Unknown block type: {type}</div>;
  }
}
